module.exports = __webpack_public_path__ + "static/media/tr.5a7974ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/tr.svg
// module id = 1472
// module chunks = 0